import { createApp } from 'vue'
import AppNotificationContainer from 'components/AppNotificationContainer.vue'

let notificationContainerInstance = null

function createNotificationContainer() {
  const container = document.createElement('div')
  document.body.appendChild(container)
  notificationContainerInstance = createApp(AppNotificationContainer).mount(container)
}

function notify(options) {
  if (!notificationContainerInstance) {
    createNotificationContainer()
  }
  // console.log('notify options', options)
  notificationContainerInstance.addNotification(options)
}

export default {
  notify(options) {
    notify(options)
  },
}
